/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changelog_Detail_Notfound1Inputs */

const id_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan tidak ditemukan`)
};

const ms_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan tidak ditemui`)
};

const da_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændring ikke fundet`)
};

const de_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderung nicht gefunden`)
};

const en_us2_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change not found`)
};

const es_es2_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio no encontrado`)
};

const es_mx2_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio no encontrado`)
};

const fil_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi nahanap ang pagbabago`)
};

const fr_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modification non trouvée`)
};

const it_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica non trovata`)
};

const hu_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Változás nem található`)
};

const nl_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijziging niet gevonden`)
};

const no_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endring ikke funnet`)
};

const pl_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmiana nie znaleziona`)
};

const pt_br2_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alteração não encontrada`)
};

const pt_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alteração não encontrada`)
};

const ro_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificare negăsită`)
};

const fi_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutosta ei löydy`)
};

const sv_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändringen hittades inte`)
};

const vi_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy thay đổi`)
};

const tr_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklik bulunamadı`)
};

const cs_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změna nenalezena`)
};

const bg_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промяната не е намерена`)
};

const ru_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменение не найдено`)
};

const uk_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зміну не знайдено`)
};

const ar_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التغيير غير موجود`)
};

const hi_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तन नहीं मिला`)
};

const th_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบการเปลี่ยนแปลง`)
};

const ja_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更が見つかりません`)
};

const zh_cn2_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到相关更改`)
};

const zh_hant1_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到相關變更`)
};

const ko_changelog_detail_notfound1 = /** @type {(inputs: Changelog_Detail_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경 사항을 찾을 수 없음`)
};

/**
* | output |
* | --- |
* | "Change not found" |
*
* @param {Changelog_Detail_Notfound1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const changelog_detail_notfound1 = /** @type {((inputs?: Changelog_Detail_Notfound1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changelog_Detail_Notfound1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_changelog_detail_notfound1(inputs)
	if (locale === "ms") return ms_changelog_detail_notfound1(inputs)
	if (locale === "da") return da_changelog_detail_notfound1(inputs)
	if (locale === "de") return de_changelog_detail_notfound1(inputs)
	if (locale === "en-US") return en_us2_changelog_detail_notfound1(inputs)
	if (locale === "es-ES") return es_es2_changelog_detail_notfound1(inputs)
	if (locale === "es-MX") return es_mx2_changelog_detail_notfound1(inputs)
	if (locale === "fil") return fil_changelog_detail_notfound1(inputs)
	if (locale === "fr") return fr_changelog_detail_notfound1(inputs)
	if (locale === "it") return it_changelog_detail_notfound1(inputs)
	if (locale === "hu") return hu_changelog_detail_notfound1(inputs)
	if (locale === "nl") return nl_changelog_detail_notfound1(inputs)
	if (locale === "no") return no_changelog_detail_notfound1(inputs)
	if (locale === "pl") return pl_changelog_detail_notfound1(inputs)
	if (locale === "pt-BR") return pt_br2_changelog_detail_notfound1(inputs)
	if (locale === "pt") return pt_changelog_detail_notfound1(inputs)
	if (locale === "ro") return ro_changelog_detail_notfound1(inputs)
	if (locale === "fi") return fi_changelog_detail_notfound1(inputs)
	if (locale === "sv") return sv_changelog_detail_notfound1(inputs)
	if (locale === "vi") return vi_changelog_detail_notfound1(inputs)
	if (locale === "tr") return tr_changelog_detail_notfound1(inputs)
	if (locale === "cs") return cs_changelog_detail_notfound1(inputs)
	if (locale === "bg") return bg_changelog_detail_notfound1(inputs)
	if (locale === "ru") return ru_changelog_detail_notfound1(inputs)
	if (locale === "uk") return uk_changelog_detail_notfound1(inputs)
	if (locale === "ar") return ar_changelog_detail_notfound1(inputs)
	if (locale === "hi") return hi_changelog_detail_notfound1(inputs)
	if (locale === "th") return th_changelog_detail_notfound1(inputs)
	if (locale === "ja") return ja_changelog_detail_notfound1(inputs)
	if (locale === "zh-CN") return zh_cn2_changelog_detail_notfound1(inputs)
	if (locale === "zh-Hant") return zh_hant1_changelog_detail_notfound1(inputs)
	return ko_changelog_detail_notfound1(inputs)
});
export { changelog_detail_notfound1 as "changelog.detail.notFound" }